import { PropertyState, PropertyType } from '../../../architecture/enums/Dataset';
import { Property } from './Property';

export class SimpleProperty extends Property {
  constructor(key: string, annotation: string, id?: string | null, state?: PropertyState) {
    super(PropertyType.Simple, key, annotation, id, state);
  }
}
